// Four-season ambient particles (Japanese traditional seasons).
// Renders 3 falling particles whose shape, tint and motion follow the active
// season; the season menu (kodama-season-menu.liquid) switches it via a
// 'kodama:season' event and persists the choice in localStorage.
// Decorative: bails out under prefers-reduced-motion.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.querySelector('.kodama-leaves');
  if (!root) return;

  var LEAF_SVG =
    '<svg class="kodama-leaf__svg" viewBox="0 0 24 24" fill="none">' +
    '<path class="kodama-leaf__fill" d="M20.5 3.5 C 13 3.2, 6.5 6.5, 4.8 13.2 C 4.2 15.6, 4.4 18, 5.4 19.6 C 7.2 20.4, 9.8 20.3, 12.2 19.3 C 18.6 16.7, 21.2 10.6, 20.5 3.5 Z"/>' +
    '<path d="M6.2 18.4 C 9.5 13.2, 13.8 9.2, 19 6.2" stroke="rgba(255,255,255,0.55)" stroke-width="0.9" stroke-linecap="round"/>' +
    '<path d="M5.4 19.6 C 4.6 20.9, 4 21.9, 3.6 22.8" stroke="rgba(0,0,0,0.25)" stroke-width="1.3" stroke-linecap="round"/>' +
    '</svg>';

  var PETAL_SVG =
    '<svg class="kodama-leaf__svg" viewBox="0 0 24 24" fill="none">' +
    '<path class="kodama-leaf__fill" d="M12 21 C 7 16, 5.5 10, 8 5.5 C 9.5 3, 11 2.6, 12 4.4 C 13 2.6, 14.5 3, 16 5.5 C 18.5 10, 17 16, 12 21 Z"/>' +
    '<path d="M12 19 C 11 14.5, 11 9.5, 12 6" stroke="rgba(255,255,255,0.5)" stroke-width="0.8" stroke-linecap="round"/>' +
    '</svg>';

  var SNOW_SVG =
    '<svg class="kodama-leaf__svg" viewBox="0 0 24 24" fill="none">' +
    '<circle class="kodama-leaf__fill" cx="12" cy="12" r="6"/>' +
    '<circle cx="10" cy="10" r="2" fill="rgba(255,255,255,0.6)"/>' +
    '</svg>';

  // Motion tuned per season: snow drifts slow with little sway, petals float
  // long and wide, leaves tumble.
  var SEASONS = {
    spring: { svg: PETAL_SVG, tints: ['#f6a8c0', '#f48fb1', '#fbc6d8'], fall: [18, 26], sway: [30, 70], swayDur: [3.6, 5.4], spin: [9, 16], size: [1.6, 2.6] },
    summer: { svg: LEAF_SVG, tints: ['#66b36c', '#4f9b57', '#7fb069'], fall: [15, 22], sway: [24, 60], swayDur: [3.2, 5], spin: [7, 13], size: [1.8, 3] },
    autumn: { svg: LEAF_SVG, tints: ['#d9822b', '#c9541f', '#e8a13c'], fall: [14, 20], sway: [28, 64], swayDur: [3, 4.6], spin: [6, 11], size: [1.8, 3] },
    winter: { svg: SNOW_SVG, tints: ['#dbe9f5', '#cfe2f1', '#eaf3fa'], fall: [22, 32], sway: [12, 28], swayDur: [4, 6], spin: [0, 0], size: [1, 1.7] },
  };

  var current = 'summer';
  var density = 3; // particle count, configurable 1-10 from the wand

  var rand = function (min, max) {
    return min + Math.random() * (max - min);
  };

  // Build/trim the particle nodes to the wanted count (they were previously
  // fixed in the snippet; now the density setting drives them).
  var ensureCount = function (n) {
    while (root.children.length < n) {
      var leaf = document.createElement('div');
      leaf.className = 'kodama-leaf';
      var sway = document.createElement('div');
      sway.className = 'kodama-leaf__sway';
      leaf.appendChild(sway);
      leaf.addEventListener('animationiteration', function (event) {
        if (event.animationName === 'kodama-leaf-fall') {
          randomize(event.currentTarget, Math.floor(rand(0, 3)));
        }
      });
      root.appendChild(leaf);
    }
    while (root.children.length > n) {
      root.removeChild(root.lastElementChild);
    }
  };

  var randomize = function (leaf, index) {
    var cfg = SEASONS[current];
    leaf.style.setProperty('--leaf-x', rand(4, 92).toFixed(1) + 'vw');
    leaf.style.setProperty('--leaf-size', rand(cfg.size[0], cfg.size[1]).toFixed(2) + 'rem');
    leaf.style.setProperty('--leaf-sway', rand(cfg.sway[0], cfg.sway[1]).toFixed(0) + 'px');
    leaf.style.setProperty('--leaf-sway-dur', rand(cfg.swayDur[0], cfg.swayDur[1]).toFixed(2) + 's');
    if (cfg.spin[1] > 0) {
      leaf.style.setProperty('--leaf-spin-dur', rand(cfg.spin[0], cfg.spin[1]).toFixed(1) + 's');
    }
    var fill = leaf.querySelector('.kodama-leaf__fill');
    if (fill) fill.setAttribute('fill', cfg.tints[index % cfg.tints.length]);
  };

  var apply = function (season) {
    // 'off' disables the effect entirely (CSS hides the layer).
    if (season === 'off') {
      root.setAttribute('data-season', 'off');
      return;
    }
    if (!SEASONS[season]) season = 'summer';
    current = season;
    root.setAttribute('data-season', season);
    ensureCount(density);
    var leaves = root.querySelectorAll('.kodama-leaf');
    leaves.forEach(function (leaf, index) {
      leaf.querySelector('.kodama-leaf__sway').innerHTML = SEASONS[season].svg;
      randomize(leaf, index);
      // Fixed duration per leaf (changing it mid-flight would jump the
      // frame); negative delays start each particle mid-fall, staggered
      // across the whole fall cycle.
      var cfg = SEASONS[season];
      var duration = rand(cfg.fall[0], cfg.fall[1]);
      leaf.style.setProperty('--leaf-fall-dur', duration.toFixed(1) + 's');
      leaf.style.setProperty(
        '--leaf-fall-delay',
        (-duration * (index / leaves.length) - rand(0, 3)).toFixed(1) + 's'
      );
    });
  };

  var store = function (k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  };

  density = Math.min(10, Math.max(1, parseInt(store('kodama_density'), 10) || 3));
  // Manual choice > date-derived auto season (set by kodama-customize-menu
  // from Theme Settings before this deferred script runs) > summer.
  apply(store('kodama_season') || (window.KODAMA_SEASONS && window.KODAMA_SEASONS.auto) || 'summer');

  document.addEventListener('kodama:season', function (event) {
    apply(event.detail);
  });

  document.addEventListener('kodama:density', function (event) {
    density = Math.min(10, Math.max(1, parseInt(event.detail, 10) || 3));
    apply(current);
  });
})();
